import { Question } from '../components/questions';
// import { apiService } from './api'

// const api = new apiService()

export const page = () => {
    // const dataUserTrivia: any = api.createUserTrivia()
    // localStorage.setItem('dataUserTrivia', JSON.stringify(dataUserTrivia));
    Question();
}